import React from 'react'
import { isArray, isEmpty, map } from 'lodash'

const Feature = ({ feature, twoCols }) => {
  if (!feature || !feature?.details || isEmpty(feature?.details)) return null

  const { title, icon, details } = feature

  return (
    <div className="feature">
      <h3 className="feature__title">{title}</h3>
      <img className="feature__icon" alt={title} src={icon} />
      <div className={`feature__details ${twoCols ? 'two-cols' : 'one-col'}`}>
        {isArray(details) ? (
          map(details, (detail, index) => (
            <span dangerouslySetInnerHTML={{ __html: detail }} key={index} />
          ))
        ) : (
          <span dangerouslySetInnerHTML={{ __html: details }} />
        )}
      </div>
    </div>
  )
}

export default Feature
